// AuthService.js
import HttpService from './HttpService';

const AuthService = {
  async login(credentials) {
    try {
      const response = await HttpService.post('/login', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async register(userData) {
    try {
      const response = await HttpService.post('/register', userData);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async logout() {
    
    try {
      console.log('auth service js ')
        // Remove the token from localStorage or a cookie
      //localStorage.removeItem('token');
        // const token = localStorage.getItem('token');
        // const headers = {
        // Authorization: `Bearer ${token}`
        // };
  
        const response = await HttpService.post('/logout');
        return response;
      } catch (error) {
        throw error;
      }
  },
  async autoLogout() {
    try {
        const response = await HttpService.post('/auto-logout');
        return response;
      } catch (error) {
        throw error;
      }
  },

  isAuthenticated() {
    // Check if the user is authenticated based on the presence of the token
    return !!localStorage.getItem('token');
  },

  getAccessToken() {
    // Retrieve the token from localStorage or a cookie
    return localStorage.getItem('token');
  },

  async forgotPassword(credentials) {
    try {
      const response = await HttpService.post('/forgot-password', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },


  async verifyOTP(credentials) {
    try {
      const response = await HttpService.post('/verify-otp', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async verifyLoginOTP(credentials) {
    try {
      const response = await HttpService.post('/verify-otp-login', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },


  async resetPassword(credentials) {
    try {
      const response = await HttpService.post('/reset-password', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },


  async changePassword(credentials) {
    try {
      const response = await HttpService.post('/change-password', credentials);
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },


  async checkAuth() {
    try {
      const response = await HttpService.get('/login-user');
      // Save the token to localStorage or a cookie
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

};

export default AuthService;
